import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import projectsData from '../data/projects.json';
import './ProjectPage.css';
import homeIcon from '../img/home-button.png';
import leftArrow from '../img/left.png';
import rightArrow from '../img/right.png';


function ProjectPage() {
  const { cohort, projectId } = useParams();
  const navigate = useNavigate();
  const project = projectsData.find(p => p.id === projectId && p.cohort === cohort);

  if (!project) {
    return <div>Project not found</div>;
  }

  // Get all projects in the same cohort for navigation
  const cohortProjects = projectsData.filter(p => p.cohort === cohort);
  const currentProjectIndex = cohortProjects.findIndex(p => p.id === projectId);
  const prevProject = cohortProjects[(currentProjectIndex - 1 + cohortProjects.length) % cohortProjects.length];
  const nextProject = cohortProjects[(currentProjectIndex + 1) % cohortProjects.length];

  // Media for the project
  const mainMedia = project.mainImages || [];
  const description = project.fullDescription || project.description || '';

  // Find the first image (jpg, jpeg, png, etc) for reflection
  const firstImage = mainMedia.find(src => /\.(jpe?g|png)$/i.test(src));

  // Helper to render media (image, gif, video)
  const renderMedia = (src, idx) => {
    const ext = src.split('.').pop().toLowerCase();
    if (["mp4", "webm", "ogg"].includes(ext)) {
      return (
        <div className={`main-image-with-overlay vertical-media${idx === 0 ? ' first-media' : ''}`} key={idx}>
          <video controls className="main-media">
            <source src={`${process.env.PUBLIC_URL}/${src}`} type={`video/${ext}`} />
            Your browser does not support the video tag.
          </video>
          {idx === 0 && (
            <div className="description-overlay">
              <div className="cohort-label">{project.cohort.replace('_', ' ').toUpperCase()}</div>
              <h1>{project.title}</h1>
              <p>{description}</p>
            </div>
          )}
        </div>
      );
    }
    return (
      <div className={`main-image-with-overlay vertical-media${idx === 0 ? ' first-media' : ''}`} key={idx}>
        <img
          src={`${process.env.PUBLIC_URL}/${src}`}
          alt={`Project media`}
          className="main-media"
        />
        {idx === 0 && (
          <div className="description-overlay">
            <div className="cohort-label">{project.cohort.replace('_', ' ').toUpperCase()}</div>
            <h1>{project.title}</h1>
            <p>{description}</p>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="project-page">
      {/* Reflection background */}
      {firstImage && (
        <>
          <img
            src={`${process.env.PUBLIC_URL}/${firstImage}`}
            alt="reflection-top"
            className="reflection reflection-top"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '9%', objectFit: 'cover', transform: 'scaleY(-1)', opacity: 0.25, zIndex: 0 }}
          />
          <img
            src={`${process.env.PUBLIC_URL}/${firstImage}`}
            alt="reflection-bottom"
            className="reflection reflection-bottom"
            style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', height: '12%', objectFit: 'cover', opacity: 0.25, zIndex: 0 }}
          />
          <img
            src={`${process.env.PUBLIC_URL}/${firstImage}`}
            alt="reflection-left"
            className="reflection reflection-left"
            style={{ position: 'absolute', top: 0, left: 0, width: '15%', height: '100%', objectFit: 'cover', transform: 'scaleX(-1)', opacity: 0.25, zIndex: 0 }}
          />
          <img
            src={`${process.env.PUBLIC_URL}/${firstImage}`}
            alt="reflection-right"
            className="reflection reflection-right"
            style={{ position: 'absolute', top: 0, right: 0, width: '15%', height: '100%', objectFit: 'cover', opacity: 0.25, zIndex: 0 }}
          />
        </>
      )}
      {/* ...existing code... */}
      <img
        src={homeIcon}
        alt="Home"
        className="home-button"
        onClick={() => navigate('/')} />
      <div className="navigation">
        <img
          src={leftArrow}
          alt="Previous Project"
          className="nav-arrow left-arrow"
          onClick={() => navigate(`/projects/${cohort}/${prevProject.id}`)}
        />
        <img
          src={rightArrow}
          alt="Next Project"
          className="nav-arrow right-arrow"
          onClick={() => navigate(`/projects/${cohort}/${nextProject.id}`)}
        />
      </div>
      <div className="project-content vertical-scroll" style={{ position: 'relative', zIndex: 1 }}>
        {mainMedia.map((src, idx) => renderMedia(src, idx))}
      </div>
    </div>
  );
}

export default ProjectPage;
